import { render, staticRenderFns } from "./DoubleColumnForm.vue?vue&type=template&id=4143db89&scoped=true&"
import script from "./DoubleColumnForm.vue?vue&type=script&lang=js&"
export * from "./DoubleColumnForm.vue?vue&type=script&lang=js&"
import style0 from "./DoubleColumnForm.vue?vue&type=style&index=0&id=4143db89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4143db89",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VFlex,VLayout,VTextField})
